import { collection, doc, getDoc } from "firebase/firestore";
import { db } from "../../firebase";
const PropertyFeatures = async (clientId) => {
  /**
   * input: null
   * output: property features object
   * description: fetches complete property features
   */
  try {
    let clientCollection = doc(db, "clients", clientId);

    let dynamicPropertyCollection = collection(
      clientCollection,
      "dynamicFields"
    );
    let propertyFeaturesCollection = doc(dynamicPropertyCollection, "property");

    const featuresSnapshot = await getDoc(propertyFeaturesCollection);
    const propertyFeatures = featuresSnapshot.data();
    return propertyFeatures;
  } catch (error) {
    console.log(error);
  }
};

export default PropertyFeatures;
